/**
 * SYM-6289 (20 Sep 2026). What the copy button in the ad toolbar calls itself.
 *
 * On a video ad the customer is looking at a video, and "variant" is our word,
 * not theirs: the button says "Duplicate video" there. On a picture ad the
 * wording stays as it was.
 *
 * The same text is the tooltip AND the button's accessible name (the tooltip
 * is the only label the icon button has), so a screen reader hears the change
 * too, and any test that finds the button by name must ask for the right one.
 */
export const duplicateButtonLabel = (isVideo: boolean): string =>
  isVideo ? 'Duplicate video' : 'Duplicate variant';
